export default "__VITE_ASSET__BKb0g$ex__"